export const validateImageDimensions = (file: File): Promise<{ valid: boolean; message?: string }> => {
  return new Promise(resolve => {
    const img = new Image()
    const url = URL.createObjectURL(file)

    img.onload = () => {
      URL.revokeObjectURL(url)

      const aspectRatio = img.height / img.width
      const targetRatio = 16 / 9
      const tolerance = 0.1

      if (Math.abs(aspectRatio - targetRatio) > tolerance) {
        resolve({
          valid: false,
          message: 'La imagen debe tener proporción 9:16 vertical',
        })
        return
      }

      if (img.width < 540 || img.height < 960) {
        resolve({
          valid: false,
          message: 'La imagen debe tener al menos 540x960 píxeles',
        })
        return
      }

      resolve({ valid: true })
    }

    img.onerror = () => {
      URL.revokeObjectURL(url)
      resolve({ valid: false, message: 'No se pudo cargar la imagen' })
    }

    img.src = url
  })
}

export const validateFileSize = (file: File): { valid: boolean; message?: string } => {
  const maxSize = 15 * 1024 * 1024 // 15MB

  if (file.size > maxSize) {
    return {
      valid: false,
      message: 'El archivo no debe superar los 15MB',
    }
  }

  return { valid: true }
}
